<template>
	<PageTitleComponent>Partnership Handbooks</PageTitleComponent>

	<section class="container band">
		<div class="cols content">
			<div class="col col-2"></div>
			<div class="col col-8 text-center">
				<p>Every partner school receives a free copy of each of the Blueprint for Partner Champions and Blueprint for Partner Principals at the commencement of their Real Schools partnership. Partner schools are welcome to order additional copies here.</p>
			</div>
		</div>

		<BookPurchaseComponent
			:hide-title="true"
			:init-books="['blue-book', 'black-book']"
		/>
	</section>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import PageTitleComponent from '@/components/shared/PageTitleComponent.vue';
import BookPurchaseComponent from '@/components/purchase/BookPurchaseComponent.vue';
import type { Resource } from '@/interfaces/resourceInterface';

export default defineComponent({
	components: { PageTitleComponent, BookPurchaseComponent },
	props: {
		resource: {
			type: Object as PropType<Resource>,
			required: true,
		},
	},
});
</script>
